module.exports = __webpack_public_path__ + "static/media/no-connection-gray.9daa2cf2.svg";